var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 306,
    height: 184,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h306v184H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#7F91A5",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2E3",
    d: "M154.5 109c20.158 0 36.5-16.342 36.5-36.5S174.658 36 154.5 36 118 52.342 118 72.5s16.342 36.5 36.5 36.5zm66.5 63.667v-11.96c0-8.638-4.154-16.583-10.977-20.988C199.158 132.724 180.331 124 154 124c-26.666 0-45.381 8.675-56.124 15.67C91.11 144.076 87 151.997 87 160.586V197h134",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profileImg.aff449b292e9b6f19e405f464e2c0a7d.svg";
export { ForwardRef as ReactComponent };